export const POSTTAGS = {
  GENERALUPDATE: { value: "general_update", label: "General Update" },
  POLICY: { value: "policy", label: "Policy" },
  OPPORTUNITY: { value: "opportunity", label: "Opportunity" },
};

export const tag_filters = ["general_update", "policy", "opportunity"];
